import React from 'react'
import { Routes, Route } from 'react-router-dom'

import Login from '@/pages/Login'
import Layout from '@/pages/Layout'
import Home from '@/pages/Home'
import AuthRoute from '@/components/AuthRoute'
import System from '@/pages/System'
import Interface from '@/pages/Interface'
import District from '@/pages/District'
import Enterprise from '@/pages/Enterprise'
import Unit from '@/pages/Unit'
import Device from '@/pages/Device'
import Data from '@/pages/Data'
import Role from '@/pages/Role'
import Authority from '@/pages/Authority'
import Video from '@/pages/Video'
import Dhsp from '@/pages/Dhsp'

export default function Router () {
  return (
    <>
      {/* 路由 */}
      <Routes>
        {/* 创建路由path和组件对应关系 */}
        <Route path='login' element={<Login />}></Route>
        {/* Layout需要做鉴权处理 */}
        <Route path='/' element={<Layout />}>
          <Route index element={<AuthRoute><Home /></AuthRoute>}> </Route>
          <Route path='/system' element={<System />}> </Route>
          <Route path='/interface' element={<Interface />}> </Route>
          <Route path='/district' element={<District />}> </Route>
          <Route path='/enterprise' element={<Enterprise />}> </Route>
          <Route path='/unit' element={<Unit />}> </Route>
          <Route path='/device' element={<Device />}> </Route>
          <Route path='/data' element={<Data />}> </Route>
          <Route path='/role' element={<Role />}> </Route>
          <Route path='/authority' element={<Authority/>}> </Route>
          <Route path='/video' element={<Video/>}> </Route>
          <Route path='/dhsp' element={<Dhsp/>}> </Route>
          {/* 此处填写路由 */}
        </Route>
      </Routes>
    </>
  )
}
